import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import Echo from "laravel-echo";

export const useSocket = (url) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {


    if (!url) {
      console.warn("Socket URL is required");
      return;
    }

    if (typeof window !== "undefined") {
      window.io = io;
      window.Echo = new Echo({
        broadcaster: "socket.io",
        host: url,
      });

      const connector = window?.Echo?.connector;
      const _socket = connector?.socket;
      _socket?.on("connect", () => {
        console.log("Connected");
      });

      _socket?.on("connect_failed", (e) => {
        console.error(`Connection failed: ${e}`);
      });

      _socket?.on("error", (e) => {
        console.error(`Socket error: ${e}`);
      });

      _socket?.on("disconnect", () => {
        console.log("Disconnected");
      });

      setSocket(window.Echo);
      return () => {
        window?.Echo?.disconnect();
      };
    }
  }, [url]);

  return socket;
};
